/** Where a brand adds or activates a LinkedIn/YouTube surface (Brand → Settings → Surfaces). */
export const brandSurfacesPath = (brandId: string) => `/brand/${encodeURIComponent(brandId)}/settings/surfaces`;

const SURFACE_LABEL: Record<string, string> = { linkedin: "LinkedIn", youtube: "YouTube", blog: "Blog" };
export const surfaceLabel = (surface: string | null | undefined) =>
  surface ? SURFACE_LABEL[surface.trim().toLowerCase()] ?? surface : "this";
